import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {
  CButton, CCard, CCardBody, CCol, CContainer, CForm, CFormInput,
  CFormLabel, CRow, CAlert, CSpinner,
} from '@coreui/react'
import { recuperarClave } from '../api/client'

/**
 * Recuperar contraseña — [RGM] diseño nuevo aprobado por Rafael (el login
 * GX/LowCode no tiene recuperación). Pide el email y el backend responde
 * SIEMPRE el mensaje genérico (no revela si el correo está registrado).
 * La página muestra ese mismo mensaje genérico en todos los casos.
 */
const RecuperarClavePage: React.FC = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [enviado, setEnviado] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await recuperarClave(email.trim())
      // El backend responde el genérico SIEMPRE (exista o no el correo)
      setEnviado(true)
      setEmail('')
    } catch (err: any) {
      setError(err.message ?? 'No se pudo procesar la solicitud')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="bg-body-tertiary min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8} lg={6} xl={5}>
            <div className="d-flex flex-column gap-4">
              <div className="text-center">
                <img src="/logo_siprinia.png" alt="SiprinIA" height={120} />
                <h1 className="h3 fw-bold mb-0 mt-2" style={{ color: 'var(--cui-body-color)' }}>
                  SiprinIA
                </h1>
              </div>
              <CCard className="p-4">
                <CCardBody className="d-flex flex-column gap-4">
                  <h2 className="h5 text-center mb-0">Recuperar contraseña</h2>
                  <p className="text-center text-body-secondary mb-0">
                    Ingresa el correo con el que te registraste
                  </p>
                  {error && <CAlert color="danger" className="mb-0">{error}</CAlert>}
                  {enviado && (
                    <CAlert color="success" className="mb-0">
                      Si el correo está registrado, recibirás un enlace para restablecer tu contraseña.
                    </CAlert>
                  )}
                  {!enviado ? (
                    <CForm className="row gy-3" onSubmit={handleSubmit}>
                      <CCol xs={12}>
                        <CFormLabel htmlFor="rec-email">Correo electrónico</CFormLabel>
                        <CFormInput
                          id="rec-email"
                          type="email"
                          placeholder="correo@empresa.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          autoComplete="email"
                          required
                        />
                      </CCol>
                      <CCol xs={12}>
                        <CButton color="primary" type="submit" disabled={loading} className="w-100">
                          {loading ? <CSpinner size="sm" /> : 'Enviar enlace'}
                        </CButton>
                      </CCol>
                    </CForm>
                  ) : (
                    <div className="text-center text-body-secondary">
                      Revisá tu casilla de correo y hacé clic en el enlace que te enviamos para
                      restablecer tu contraseña.
                    </div>
                  )}
                </CCardBody>
              </CCard>
              <div className="text-center text-body-secondary">
                <Link to="/login" className="text-decoration-none">Volver al inicio de sesión</Link>
              </div>
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default RecuperarClavePage
